// const adminSections = {
//     main: { key: 'main', name: 'Main Options', },
//     website: { key: 'website', name: 'Website Options', },
//     extra: { key: 'extra', name: 'Extra Options', },
//     admin: { key: 'admin', name: 'Admin Options', },
//     // settings: { key: 'settings', name: 'Settings Options', },

import { tradingPages } from "./tradingPages"

// }

const tradingWidgets = {


    // "reservedRentals": {
    //     key: 'TableWidget',
    //     page: 'rental',

    //     col: '12',
    //     title: 'Reserved Rentals',
    //     headers: adminPages.rental.headers,
    //     pages: adminPages.rental.pages,
    //     // permissionParent: 'permissions',
    //     permissionParent: 'admin.rental',


    //     fetchUrl: 'getRentals',
    //     addUrl: 'addRental',
    //     editUrl: 'addRental',
    //     removeUrl: 'removeRental',
    //     populate: ["category"],

    //     postBody: { "status": '0', archived: { $ne: true } },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },



    "pendingEquipments": {
        key: 'TableWidget',
        page: 'tequipments',

        col: '12',
        title: 'Pending Equipments',
        headers: tradingPages.tequipments.headers,
        permissionParent: 'trading.tequipments',

        fetchUrl: 'getAllTEquipments',
        addUrl: 'postTEquipments',
        editUrl: 'postTEquipments',
        removeUrl: 'removeTEquipments',
        postBody: { "active": { "$ne": '1' } },
        populate: ["category"],
        actions: {
            edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
        },
    },



    // "pendingPartners": {
    //     key: 'TableWidget',
    //     page: 'users',

    //     col: '12',
    //     title: 'Pending Partners',
    //     headers: adminPages.users.headers,
    //     permissionParent: 'admin.users',

    //     fetchUrl: 'getUsers',
    //     addFetch: 'addUser',
    //     removeUrl: 'removeUser',
    //     postBody: { "status": 1 },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },


    // "pendingEnquiries": {
    //     key: 'TableWidget',
    //     page: 'enquiries',

    //     col: '12',
    //     title: 'Pending Enquiries',
    //     headers: adminPages.enquiries.headers,
    //     permissionParent: 'admin.enquiries',

    //     fetchUrl: 'getAll',
    //     addUrl: 'addValue',
    //     editUrl: 'addValue',
    //     removeUrl: 'removeValue',
    //     postBody: { "values.status": '0' },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },


    // "usersActivity": {
    //     key: 'TableWidget',
    //     page: 'logs',

    //     col: '12',
    //     title: 'Users activities',
    //     headers: adminPages.logs.headers,
    //     permissionParent: 'admin.logs',

    //     fetchUrl: 'getInbox',
    //     addUrl: 'addInbox',
    //     editUrl: 'addInbox',
    //     removeUrl: 'removeInbox',
    //     // postBody: { "values.status": 1 },
    //     actions: {
    //         // edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData" },
    //     },

    // }





}


export { tradingWidgets }